// extracted by mini-css-extract-plugin
export default {"table-head":"QPBbzgryHXGRpvi","sticky":"B1tbw_GELCreGPK","table-head-row":"xPDERyaieGU3Puo"};